import React, { useEffect, useState } from "react";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import CustomSelectIcon from "./SelectBarview";
import { updateUser, getErrorByField, getUserById } from "../../Api/auth";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { ProgressBar, Step } from "react-step-progress-bar";
import { BsCheck2 } from "react-icons/bs";
import Modal from 'react-bootstrap/Modal';
import { getclubFollowbyid, updatecluborder, getclubfollowactivityapi } from "../../Api/iron";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { useLocation } from 'react-router-dom';

function ClubFollowView() {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const params = useParams();

    const [notes, setNotes] = useState("");
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);
    const [clubfollowactivity, setClubFollowActivity] = useState([]);

    const [stagenotes, setStageNotes] = useState("");
    const [updatestageapicall, setUpdatestageapicall] = useState(false);


    const [selectedOption, setSelectedOption] = useState();
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };


    const cards = {
        "1": {
            id: 1,
            name: 'Sole Design',
            title: 'Low',
            image1: require('../../assets/images/step-images/Bounce_Low_desktop.jpg'),
            image2: require('../../assets/images/step-images/Bounce_Low_Mobile.jpg'),
            selected: false
        },
        "2":
        {
            id: 2,
            name: 'Sole Design',
            title: 'Mid',
            image1: require('../../assets/images/step-images/Bounce_Mid_desktop.jpg'),
            image2: require('../../assets/images/step-images/Bounce_Mid_Mobile.jpg'),
            selected: false
        },
        "3": {
            id: 3,
            name: 'Sole Design',
            title: 'High',
            image1: require('../../assets/images/step-images/Bounce_High_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Bounce_High_Mobile.jpg'),
            selected: false
        }
    };

    const finish = {
        "1": {
            id: 1,
            name: 'Head Finish',
            title: 'Satin',
            image1: require('../../assets/images/step-images/Finish_Satin_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Finish_Satin_Mobile.png'),
            selected: false
        },
        "2":
        {
            id: 2,
            name: 'Head Finish',
            title: 'Black',
            image1: require('../../assets/images/step-images/Finish_Black_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Finish_Black_Mobile.png'),
            selected: false
        },
        "3": {
            id: 3,
            name: 'Head Finish',
            title: 'Copper',
            image1: require('../../assets/images/step-images/Finish_Copper_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Finish_Copper_Mobile.png'),
            selected: false
        }
    }

    const ports = {
        "1": {
            id: 1,
            name: 'Port Finish',
            title: 'Silver',
            image1: require('../../assets/images/step-images/SilverPorts_Desktop.jpg'),
            image2: require('../../assets/images/step-images/SilverPorts_Mobile.png'),
            selected: false
        },
        "2":
        {
            id: 2,
            name: 'Port Finish',
            title: 'Black',
            image1: require('../../assets/images/step-images/BlackPorts_Desktop.jpg'),
            image2: require('../../assets/images/step-images/BlackPorts_Mobile.png'),
            selected: false
        },
        "3": {
            id: 3,
            name: 'Port Finish',
            title: 'Gold',
            image1: require('../../assets/images/step-images/GoldPorts_Desktop.jpg'),
            image2: require('../../assets/images/step-images/GoldPorts_Mobile.png'),
            selected: false
        }
    }

    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [apicall, setApicall] = useState(false);

    const dataChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: ""
    };

    const [formData, setFormData] = useState(initData);

    const SettingIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M2205 5106 c-36 -15 -83 -68 -90 -99 -3 -12 -17 -74 -33 -137 l-28 -115 -60 -18 c-230 -69 -383 -131 -537 -219 l-88 -50 -103 61 c-146 87 -176 97 -229 81 -35 -10 -81 -51 -270 -238 -243 -242 -273 -282 -261 -346 3 -20 31 -77 61 -128 95 -160 91 -136 35 -236 -88 -157 -162 -336 -207 -497 -13 -48 -28 -91 -32 -95 -4 -4 -66 -21 -137 -38 -131 -31 -163 -46 -200 -96 -20 -27 -21 -40 -21 -376 0 -338 1 -349 21 -377 36 -48 76 -67 208 -97 105 -24 129 -33 136 -50 4 -12 28 -84 53 -161 47 -146 101 -275 114 -275 4 0 163 159 353 353 l346 352 -14 125 c-52 493 179 979 594 1252 385 253 851 295 1281 117 249 -104 485 -314 628 -559 188 -322 232 -730 119 -1091 -103 -331 -357 -630 -666 -786 -226 -114 -515 -168 -765 -142 l-115 12 -351 -351 -351 -351 69 -32 c57 -26 234 -87 365 -127 22 -7 28 -21 57 -142 34 -138 48 -168 97 -204 27 -20 40 -21 376 -21 336 0 349 1 376 21 50 37 66 70 98 205 l31 134 60 18 c228 68 384 131 538 219 l87 50 123 -71 c67 -38 135 -73 150 -77 62 -15 101 14 344 258 301 303 294 281 162 504 l-61 103 50 88 c88 154 151 310 219 538 l18 60 134 32 c137 32 168 47 205 97 20 27 21 40 21 376 0 336 -1 349 -21 376 -37 50 -68 65 -205 97 l-134 32 -18 60 c-68 228 -131 384 -219 538 l-50 88 61 103 c132 223 139 201 -162 504 -243 244 -282 273 -344 258 -15 -4 -83 -39 -150 -77 l-123 -71 -87 50 c-154 88 -310 151 -538 219 l-60 18 -31 134 c-32 135 -48 168 -98 205 -26 20 -42 21 -364 23 -265 2 -344 0 -367 -11z" />
                <path d="M2435 3603 c-641 -82 -1060 -712 -883 -1327 l20 -69 -749 -751 c-700 -701 -751 -755 -777 -814 -79 -181 -45 -374 88 -508 134 -133 327 -167 508 -88 59 26 113 77 814 777 l752 749 48 -15 c112 -35 162 -42 309 -42 131 1 164 4 260 29 237 60 421 178 558 359 157 205 237 459 223 709 -11 212 -49 304 -136 326 -79 20 -97 8 -320 -213 -113 -111 -218 -209 -235 -217 -83 -43 -196 -43 -278 -2 -150 76 -207 276 -120 418 14 23 112 129 218 236 210 213 223 231 203 310 -14 56 -62 95 -133 110 -133 28 -269 36 -370 23z" />
            </g>
        </svg>
    );

    const Contact = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M967 4756 c-21 -8 -64 -32 -95 -54 -31 -21 -190 -130 -352 -242 -162 -111 -297 -204 -299 -206 -10 -9 -32 -132 -42 -239 -54 -580 268 -1511 805 -2324 195 -295 366 -509 591 -740 288 -296 555 -484 817 -576 l77 -27 386 183 c228 109 403 198 426 218 22 18 49 52 61 75 28 55 36 159 15 208 -30 72 -410 720 -439 749 -64 63 -165 91 -247 69 -24 -6 -142 -65 -261 -131 -120 -65 -223 -119 -230 -119 -31 0 -260 263 -405 466 -174 243 -399 656 -504 923 -44 112 -121 354 -121 381 0 4 101 69 225 144 142 87 235 150 254 174 56 67 76 173 48 252 -15 40 -388 689 -424 736 -55 73 -198 113 -286 80z" />
                <path d="M1906 4008 c25 -68 29 -192 10 -267 -9 -35 -15 -65 -14 -66 2 -1 259 -177 572 -391 313 -214 573 -388 577 -387 6 2 1111 758 1659 1135 24 16 -56 17 -1397 17 l-1422 1 15 -42z" />
                <path d="M4085 3313 c-467 -321 -883 -606 -924 -633 -125 -84 -61 -115 -775 375 -340 233 -624 421 -630 418 -6 -4 -31 -21 -56 -38 -25 -18 -96 -62 -157 -100 -62 -37 -113 -71 -113 -76 0 -5 19 -60 41 -122 107 -290 305 -660 502 -937 74 -103 196 -257 228 -287 l24 -21 165 89 c122 66 183 93 238 105 126 28 265 3 373 -67 87 -56 148 -134 279 -363 l125 -217 700 3 c637 3 703 5 731 20 44 24 91 81 103 125 13 44 15 2281 3 2299 -4 7 -326 -208 -857 -573z" />
            </g>
        </svg>
    );

    const Calculation = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M706 4994 c-59 -21 -98 -56 -131 -115 l-30 -54 -3 -2097 -2 -2098 382 0 c211 0 534 3 718 6 l335 7 -178 353 -177 354 2 1517 c3 1498 3 1518 23 1551 11 18 36 43 55 55 34 21 47 22 325 25 285 3 291 2 335 -20 33 -17 51 -35 68 -68 l22 -44 0 -1511 -1 -1510 -177 -352 -178 -353 614 0 c663 0 666 0 676 -53 3 -12 7 -80 10 -152 5 -146 16 -182 72 -245 47 -52 106 -74 184 -68 79 6 133 43 172 117 l28 53 0 629 0 629 -478 0 c-536 0 -550 2 -623 67 -22 20 -50 55 -62 77 l-22 41 -3 1314 c-3 1459 -6 1378 64 1459 20 24 55 53 78 65 41 22 47 22 539 25 l497 3 0 112 c0 129 -14 169 -76 229 -76 73 35 68 -1573 67 -1229 0 -1452 -3 -1485 -15z m629 -1049 c32 -31 34 -96 5 -125 -19 -19 -33 -20 -259 -20 -132 0 -247 3 -256 6 -19 8 -45 55 -45 84 0 12 13 35 29 51 l29 29 237 0 236 0 24 -25z m0 -890 c35 -34 34 -86 -1 -114 -25 -20 -39 -21 -253 -21 -243 0 -263 4 -290 52 -12 20 -13 34 -6 55 18 49 40 53 293 53 l233 0 24 -25z m6 -884 c26 -32 24 -77 -6 -106 l-24 -25 -235 0 -234 0 -31 26 c-17 14 -31 36 -31 48 0 28 26 65 54 76 11 5 126 8 254 7 232 -2 234 -2 253 -26z m-35 -861 c38 -15 53 -38 54 -82 0 -28 -6 -41 -26 -57 -25 -20 -39 -21 -260 -21 l-232 0 -31 26 c-49 41 -38 103 22 129 39 17 430 21 473 5z" />
                <path d="M2860 4410 c-20 -20 -20 -33 -20 -1330 0 -1297 0 -1310 20 -1330 20 -20 33 -20 1075 -20 1042 0 1055 0 1075 20 20 20 20 33 20 1333 0 1260 -1 1315 -18 1330 -17 16 -106 17 -1075 17 -1044 0 -1057 0 -1077 -20z m1831 -380 c16 -22 19 -48 20 -230 l1 -204 -27 -23 -27 -23 -725 2 -725 3 -19 24 c-17 21 -19 41 -19 232 0 196 1 210 20 229 20 20 31 20 751 18 l732 -3 18 -25z m-1181 -910 c31 -31 36 -68 13 -98 -20 -26 -24 -27 -137 -30 -126 -3 -151 4 -167 45 -11 31 4 78 30 93 9 5 67 10 129 10 98 0 114 -2 132 -20z m550 10 c10 -5 24 -26 30 -46 11 -32 10 -39 -7 -63 -20 -25 -23 -26 -145 -29 -115 -2 -126 -1 -143 18 -27 30 -25 88 4 111 20 16 41 19 133 19 60 0 118 -4 128 -10z m560 0 c10 -5 24 -26 30 -46 11 -32 10 -39 -7 -63 -20 -25 -23 -26 -145 -29 -118 -2 -125 -1 -145 20 -34 36 -34 77 -1 108 19 18 35 20 136 20 62 0 122 -4 132 -10z m-1107 -498 c9 -10 20 -32 23 -49 5 -26 1 -37 -19 -57 -25 -25 -31 -26 -136 -26 -60 0 -117 3 -126 6 -24 10 -46 60 -39 89 11 46 38 55 165 55 99 0 118 -3 132 -18z m542 12 c18 -7 45 -55 45 -79 0 -9 -11 -27 -25 -40 -23 -24 -30 -25 -138 -25 -136 0 -161 12 -161 75 0 63 25 75 154 75 60 0 116 -3 125 -6z m565 -4 c25 -13 41 -65 30 -95 -14 -37 -41 -45 -159 -45 -100 0 -112 2 -135 23 -36 32 -39 74 -6 107 18 18 33 20 136 20 63 0 124 -4 134 -10z m-1117 -500 c27 -22 41 -61 32 -91 -12 -35 -57 -49 -164 -49 -90 0 -102 2 -127 23 -20 17 -27 33 -27 57 0 24 7 40 27 57 25 21 37 23 130 23 88 0 107 -3 129 -20z m555 4 c51 -35 48 -109 -4 -133 -14 -6 -70 -11 -125 -11 -98 0 -101 1 -130 29 -16 16 -29 39 -29 51 0 12 13 35 29 51 29 28 32 29 133 29 79 0 109 -4 126 -16z m564 -4 c46 -36 42 -106 -9 -129 -33 -15 -212 -14 -243 2 -38 19 -54 60 -38 94 20 42 52 53 164 53 86 0 105 -3 126 -20z" />
                <path d="M1780 3490 l0 -840 250 0 250 0 0 840 0 840 -250 0 -250 0 0 -840z" />
                <path d="M1780 1930 l0 -540 122 -245 c68 -135 125 -245 128 -245 3 0 60 110 128 245 l122 245 0 540 0 540 -250 0 -250 0 0 -540z" />
                <path d="M80 388 c0 -46 5 -100 11 -122 14 -51 91 -128 145 -144 32 -9 391 -12 1551 -12 l1510 0 -31 61 c-27 55 -30 72 -34 180 l-4 119 -1574 0 -1574 0 0 -82z" />
            </g>
        </svg>
    );

    const Calculator = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M78 5099 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -55 -20 -2315 0 -2261 0 -2276 20 -2315 13 -26 34 -47 60 -60 39 -20 53 -20 1153 -18 l1114 3 -68 95 c-161 224 -261 466 -311 750 -17 98 -17 422 0 520 8 41 26 125 42 185 173 661 741 1169 1418 1265 l82 12 0 920 c0 901 0 920 -20 958 -13 26 -34 47 -60 60 -39 20 -55 20 -1677 20 -1611 -1 -1639 -1 -1675 -21z m2712 -649 c26 -13 47 -34 60 -60 19 -37 20 -58 20 -470 0 -412 -1 -433 -20 -470 -13 -26 -34 -47 -60 -60 -39 -20 -57 -20 -1031 -20 l-991 0 -40 22 c-79 45 -78 40 -78 530 1 487 0 478 76 524 l39 24 993 0 c975 0 993 0 1032 -20z m-1680 -1440 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -150 -20 -134 0 -178 17 -210 80 -38 74 -16 153 56 196 35 21 51 24 152 24 93 0 120 -3 152 -20z m800 0 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -150 -20 -134 0 -178 17 -210 80 -38 74 -16 153 56 196 35 21 51 24 152 24 93 0 120 -3 152 -20z m-800 -800 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -151 -20 -97 0 -116 3 -151 22 -101 57 -102 194 -2 254 35 21 51 24 152 24 93 0 120 -3 152 -20z m0 -800 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -32 -16 -59 -20 -151 -20 -97 0 -116 3 -151 22 -101 57 -102 194 -2 254 35 21 51 24 152 24 93 0 120 -3 152 -20z" />
                <path d="M950 3920 l0 -250 810 0 810 0 0 250 0 250 -810 0 -810 0 0 -250z" />
                <path d="M3480 2856 c-318 -50 -594 -189 -811 -408 -452 -455 -548 -1141 -238 -1703 70 -127 137 -215 253 -330 199 -198 438 -326 719 -387 146 -31 408 -31 553 0 139 30 241 65 364 127 396 199 677 565 772 1008 31 146 31 408 0 554 -62 288 -188 520 -397 728 -208 208 -462 344 -747 400 -112 22 -360 28 -468 11z m266 -602 c42 -20 73 -62 81 -108 5 -29 12 -36 61 -56 31 -13 77 -44 103 -69 61 -60 72 -110 37 -178 -44 -89 -135 -108 -228 -48 -102 65 -220 31 -220 -64 0 -27 72 -68 210 -122 58 -22 123 -51 146 -64 56 -33 121 -106 152 -173 24 -51 27 -69 27 -168 0 -107 -1 -112 -38 -186 -42 -86 -124 -170 -199 -206 -42 -19 -46 -24 -50 -65 -20 -178 -261 -182 -297 -6 -5 26 -14 33 -71 53 -178 62 -242 150 -191 262 14 31 30 47 63 63 60 29 81 27 167 -16 65 -32 84 -36 150 -37 64 -1 81 3 109 22 41 30 62 70 62 120 0 54 -32 83 -128 117 -108 38 -242 109 -297 157 -60 53 -91 108 -106 189 -29 159 47 320 189 401 42 24 52 35 52 56 0 40 41 103 80 123 43 23 91 24 136 3z" />
            </g>
        </svg>
    );

    const Invoice = (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M944 4832 c-100 -35 -184 -117 -226 -220 l-23 -57 -3 -2075 -2 -2075 22 -45 c34 -66 79 -93 149 -88 59 4 66 9 509 314 l106 72 229 -165 c309 -223 310 -223 364 -223 26 0 58 7 73 14 15 8 115 92 223 186 l196 171 195 -171 c107 -95 207 -178 222 -186 15 -8 48 -14 73 -14 54 0 42 -8 366 224 122 87 224 158 228 159 4 0 131 -85 283 -189 265 -181 278 -188 331 -192 66 -4 111 20 145 78 l21 35 0 2085 0 2085 -23 57 c-29 71 -75 129 -137 174 -97 68 15 64 -1709 64 -1462 -1 -1564 -2 -1612 -18z m2553 -858 c98 -73 98 -195 0 -268 -28 -21 -31 -21 -937 -21 -906 0 -909 0 -937 21 -89 66 -99 179 -21 251 12 12 34 26 48 32 16 6 340 9 922 8 893 -2 897 -2 925 -23z m-17 -846 c66 -34 93 -79 88 -149 -5 -65 -32 -109 -82 -133 -31 -14 -124 -16 -926 -16 -802 0 -895 2 -926 16 -50 24 -77 68 -82 133 -5 70 22 115 88 149 l44 22 876 0 876 0 44 -22z m-840 -860 c48 -33 72 -70 77 -120 7 -58 -23 -118 -74 -149 l-38 -24 -460 -3 -460 -3 -45 23 c-66 34 -93 79 -88 149 5 64 31 108 80 132 29 15 91 17 504 17 l471 0 33 -22z" />
            </g>
        </svg>
    );


    const dropdownStatusOptions = [
        {
            label: 'Inquiry',
            icon: SettingIcon,
            value: '0',
        },
        {
            label: 'Contacted',
            icon: Contact,
            value: '1',
        },
        {
            label: 'Estimated',
            icon: Calculation,
            value: '2',
        },
        {
            label: 'Invoiced',
            icon: Calculator,
            value: '3',
        },
        {
            label: 'Purchase',
            icon: Invoice,
            value: '4',
        },
    ];


    const [selectedKeyword, setSelectedKeyword] = useState(dropdownStatusOptions[0]);
    const [bouncedata, setbouncedata] = useState(null);
    const [finishdata, setfinishdata] = useState(null);
    const [portsdata, setportsdata] = useState(null);
    const [lastkeyword, setlastkeyword] = useState(dropdownStatusOptions[0]);

    console.log("lastkeyword", lastkeyword);

    const userData = localStorage.getItem("user");
    const userJson = JSON.parse(userData);


    const handleKeywordSelect = (option) => {
        const selectedValue = option.value;
        setSelectedKeyword(option);
    };

    useEffect(() => {
        if (updatestageapicall == true) {
            const data = {
                id: params.id,
                user_id: userJson.user._id,
                stage: selectedKeyword.value,
                last_stage: lastkeyword.label,
                update_state: selectedKeyword.label,
                notes: stagenotes
            }

            updatecluborder(data).then((response) => {
                if (!response.data.status) {
                    setErrors(response.data.message);
                    alert(response.data.message);
                } else {
                    const data = response.data.data;
                    handleShow();
                    getFilteredFollowups();
                    getclubfollowactivity();
                    setUpdatestageapicall(false);
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setApicall(false);
                setValidated(true);
            });
        }
    }, [updatestageapicall]);


    useEffect(() => {
        getFilteredFollowups();
        getclubfollowactivity();
    }, []);

    const getFilteredFollowups = () => {
        setApicall(true);
        const data = {
            id: params.id
        }
        getclubFollowbyid(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.message);
                alert(response.data.message);
            } else {
                const data = response.data.data;
                setFormData({
                    firstname: data.firstname || "",
                    lastname: data.lastname || "",
                    email: data.email || "",
                    phone: data.phone,
                });
                setNotes(data.notes);
                setbouncedata(data.bounce);
                setfinishdata(data.finish);
                setportsdata(data.ports);

                let fit = dropdownStatusOptions.find((item) => data.stage === item.value)
                setSelectedKeyword(fit)
                setlastkeyword(fit);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    const getclubfollowactivity = () => {
        setApicall(true);
        const data = {
            id: params.id
        }
        getclubfollowactivityapi(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.message);
                alert(response.data.message);
            } else {
                const data = response.data.data;
                setClubFollowActivity(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    function goBack() {
        window.history.back()
    }



    return (
        <>
            <Modal
                show={show} // Show the modal when `show` is true
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">Stage update successfully</h3>
                </Modal.Body>
            </Modal>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="mobile-section show_mobile">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="button-section">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="back-btn w-100">
                                                        <button className="btn back-btn-color w-100" onClick={goBack}>
                                                            <i className="arrow-left" aria-hidden="true"><IoIosArrowBack /></i> Follow Ups
                                                        </button>
                                                    </div>
                                                    <div className={`custom-select activity_select w-100 ${isOpen ? 'open' : ''}`}>
                                                        <div className="selected-option-drop justify-content-center" onClick={toggleDropdown}>
                                                            <span className="selected-option-text xt094">Activity</span>
                                                            <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                <i className="bi bi-chevron-down" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {isOpen && (
                                                    <div className="activity-mobile-details">
                                                        <div className="col-lg-12">
                                                            <div className="d-flex justify-content-between align-items-center gap-4">
                                                                <div className="middle-heading mb-0" style={{ color: '#ffffff' }}>
                                                                    <h3>Activity</h3>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="dashboard-sec">
                                                            <Swiper
                                                                modules={[Scrollbar, Mousewheel]}
                                                                spaceBetween={10}
                                                                slidesPerView="auto"
                                                                freeMode={true}
                                                                onSlideChange={() => console.log('slide change')}
                                                                onSwiper={(swiper) => console.log(swiper)}
                                                                // centeredSlides={true}
                                                                mousewheel={{ forceToAxis: true }}
                                                                breakpoints={{
                                                                    500: {
                                                                        slidesPerView: 1,
                                                                        spaceBetween: 10
                                                                    },
                                                                    640: {
                                                                        slidesPerView: 2,
                                                                        spaceBetween: 10
                                                                    },
                                                                    768: {
                                                                        slidesPerView: 2,
                                                                        spaceBetween: 30
                                                                    },
                                                                    992: {
                                                                        slidesPerView: 3,
                                                                        spaceBetween: 30
                                                                    },
                                                                }}
                                                                className="our_process_slider"
                                                            >
                                                                {
                                                                    clubfollowactivity && clubfollowactivity.map((item, index) => (
                                                                        <SwiperSlide className="" key={index}>
                                                                            <div className="form-box-section mt-4">
                                                                                <div className="form-list-inner">
                                                                                    <div className="form-list-title activity-title">
                                                                                        <div className="emp-name">
                                                                                            <div className="emp-light">Employee:</div>
                                                                                            <div className="emp-bold">{item.firstname + " " + item.lastname}</div>
                                                                                        </div>
                                                                                        <div className="emp-status">
                                                                                            <div className="emp-light">Status:</div>
                                                                                            <div className="emp-bold">{item.what_change}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="form-card-body-status">
                                                                                        {item.notes}
                                                                                    </div>
                                                                                    <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                </div>
                                                                            </div>
                                                                        </SwiperSlide>
                                                                    ))
                                                                }
                                                            </Swiper>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="drop-down">
                                                    <CustomSelectIcon
                                                        options={dropdownStatusOptions}
                                                        defaultSelected={selectedKeyword}
                                                        onSelect={handleKeywordSelect}
                                                        ontextchange={(text) => { setStageNotes(text) }}
                                                        onpopclose={(activity) => { setUpdatestageapicall(activity) }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7 col-lg-8 col-xl-9">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="back-btn hide_mobile">
                                                        <button className="btn back-btn-color" onClick={goBack}>
                                                            <i className="arrow-left" aria-hidden="true"><IoIosArrowBack /></i> Club Sale Follow Ups
                                                        </button>
                                                    </div>
                                                    <div className="">
                                                        <div className="middle-heading mb-0" style={{ color: '#ffffff' }}>
                                                            <h3>Customer</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="dashboard-sec">
                                            <div className="container-fluid">
                                                <Form noValidate validated={validated}>
                                                    <div className="form-box-section mt-4">
                                                        <div className="form-box-inner">
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Name</label>
                                                                    <input type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "firstname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="First"
                                                                        disabled
                                                                        value={formData.firstname}
                                                                        name={"firstname"}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <input type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 ${errors.length > 0 ? getErrorByField(errors, "lastname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="Last"
                                                                        disabled
                                                                        name={"lastname"}
                                                                        value={formData.lastname}
                                                                        onChange={(e) => dataChange(e)} />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                        placeholder="Email Address"
                                                                        name="email"
                                                                        disabled
                                                                        required
                                                                        value={formData.email}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter valid email"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Phone</label>
                                                                    <input type="text" name={"phone"} disabled className="form-control dashboard-input-box-3" placeholder="Phone Number" value={formData.phone} onChange={(e) => dataChange(e)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className="sec-btn-group mt-4 update-sec">
                                                <Link to="/dashboard">
                                                    <button className="btn btn-cancel">Exit without saving</button>
                                                </Link>
                                                {apicall ? (
                                                    <button className="btn btn-save"><Spinner animation="border" className="border-black" /> </button>
                                                ) : (
                                                    <button className="btn btn-save" type="submit">Update Profile</button>
                                                )}
                                            </div> */}
                                                </Form>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <div className="middle-heading">
                                                        <h3>Clubs</h3>
                                                    </div>
                                                </div>


                                                <div className="custom_md_100 hide_mobile">
                                                    <div className="row align-items-center">
                                                        <div className='col-lg-4 col-md-4 col-sm-4'>
                                                            <div className="step-img mb-4">
                                                                <img
                                                                    src={bouncedata && cards[bouncedata.id] && cards[bouncedata.id]?.image1 ? cards[bouncedata.id]?.image1 : require('../../assets/images/thumb_img.jpg')}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-4 col-md-4 col-sm-4'>
                                                            <div className="step-img mb-4">
                                                                <img
                                                                    src={finishdata && finish[finishdata.id] && finish[finishdata.id]?.image1 ? finish[finishdata.id]?.image1 : require('../../assets/images/thumb_img.jpg')}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-4 col-md-4 col-sm-4'>
                                                            <div className="step-img mb-4">
                                                                <img
                                                                    src={portsdata && ports[portsdata.id] && ports[portsdata.id]?.image1 ? ports[portsdata.id]?.image1 : require('../../assets/images/thumb_img.jpg')}
                                                                    alt=""
                                                                />

                                                            </div>
                                                        </div>

                                                        <div className='col-lg-12'>
                                                            <div className='set_step'>
                                                                <ProgressBar
                                                                    percent="100"
                                                                    filledBackground="#99ea24"
                                                                >
                                                                    <Step transition="scale" >
                                                                        {({ accomplished }) => (
                                                                            <div className={`iron_step_icon dash_icon_step active`}>
                                                                                <BsCheck2 />
                                                                            </div>
                                                                        )}
                                                                    </Step>
                                                                    <Step transition="scale">
                                                                        {({ accomplished }) => (
                                                                            <div className={`iron_step_icon dash_icon_step active`}>
                                                                                <BsCheck2 />
                                                                            </div>
                                                                        )}
                                                                    </Step>
                                                                    <Step transition="scale">
                                                                        {({ accomplished }) => (
                                                                            <div className={`iron_step_icon dash_icon_step active`}>
                                                                                <BsCheck2 />
                                                                            </div>
                                                                        )}
                                                                    </Step>
                                                                </ProgressBar>

                                                                <div className='text_item'>
                                                                    <div className='text_step_1'>
                                                                        <span>Sole Design</span>
                                                                        <h4>{bouncedata && cards[bouncedata.id] && cards[bouncedata.id]?.title}</h4>
                                                                    </div>
                                                                    <div className='text_step_1'>
                                                                        <span>Club Finish</span>
                                                                        <h4>{finishdata && finish[finishdata.id] && finish[finishdata.id]?.title}</h4>
                                                                    </div>
                                                                    <div className='text_step_1'>
                                                                        <span>Port Finish</span>
                                                                        <h4>{portsdata && ports[portsdata.id] && ports[portsdata.id]?.title}</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="custom_md_100 show_mobile">
                                                    <div className="row align-items-center">
                                                        <div className='col-lg-12'>
                                                            <div className='img_list'>
                                                                <div className="step-img-mobile">
                                                                    <img
                                                                        src={bouncedata && cards[bouncedata.id] && cards[bouncedata.id]?.image1 ? cards[bouncedata.id]?.image1 : require('../../assets/images/thumb_img.jpg')}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="step-img-mobile">
                                                                    <img
                                                                        src={finishdata && finish[finishdata.id] && finish[finishdata.id]?.image1 ? finish[finishdata.id]?.image1 : require('../../assets/images/thumb_img.jpg')}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="step-img-mobile">
                                                                    <img
                                                                        src={portsdata && ports[portsdata.id] && ports[portsdata.id]?.image1 ? ports[portsdata.id]?.image1 : require('../../assets/images/thumb_img.jpg')}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-12'>
                                                            <div className='set_step'>
                                                                <ProgressBar
                                                                    percent="100"
                                                                    filledBackground="#99ea24"
                                                                >
                                                                    <Step transition="scale" >
                                                                        {({ accomplished }) => (
                                                                            <div className={`iron_step_icon dash_icon_step active`}>
                                                                                <BsCheck2 />
                                                                            </div>
                                                                        )}
                                                                    </Step>
                                                                    <Step transition="scale">
                                                                        {({ accomplished }) => (
                                                                            <div className={`iron_step_icon dash_icon_step active`}>
                                                                                <BsCheck2 />
                                                                            </div>
                                                                        )}
                                                                    </Step>
                                                                    <Step transition="scale">
                                                                        {({ accomplished }) => (
                                                                            <div className={`iron_step_icon dash_icon_step active`}>
                                                                                <BsCheck2 />
                                                                            </div>
                                                                        )}
                                                                    </Step>
                                                                </ProgressBar>

                                                                <div className='text_item'>
                                                                    <div className='text_step_1'>
                                                                        <span>Sole Design</span>
                                                                        <h4>{bouncedata && cards[bouncedata.id] && cards[bouncedata.id]?.title}</h4>
                                                                    </div>
                                                                    <div className='text_step_1 border_step'>
                                                                        <span>Club Finish</span>
                                                                        <h4>{finishdata && finish[finishdata.id] && finish[finishdata.id]?.title}</h4>
                                                                    </div>
                                                                    <div className='text_step_1'>
                                                                        <span>Port Finish</span>
                                                                        <h4>{portsdata && ports[portsdata.id] && ports[portsdata.id]?.title}</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="middle-heading">
                                                    <h3>Notes</h3>
                                                </div>

                                                <div className="form-box-section mb-3">
                                                    <textarea className="dashboard-text-area" disabled value={notes} id="exampleFormControlTextarea1" rows="8" placeholder="Leave your note here..." ></textarea>
                                                </div>

                                                <div className="sec-btn-group mt-4">
                                                    <button className="btn btn-cancel" onClick={goBack}>Exit without saving</button>
                                                    {/* {

                                                                apicall ? (
                                                                    <Spinner animation="border" className="border-black" />
                                                                ) : (
                                                                    <button onClick={updateFittingData} className="btn btn-save">Update fitting Data</button>
                                                                )
                                                            } */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-5 col-lg-4 col-xl-3 hide_mobile fix-col">
                                        <div className="container-fluid ps-0">
                                            <div className="drop-down">
                                                <CustomSelectIcon
                                                    options={dropdownStatusOptions}
                                                    defaultSelected={selectedKeyword}
                                                    onSelect={handleKeywordSelect}
                                                    ontextchange={(text) => { setStageNotes(text) }}
                                                    onpopclose={(activity) => { setUpdatestageapicall(activity) }}
                                                />
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="d-flex justify-content-between align-items-center gap-4">
                                                    <div className="middle-heading mb-0" style={{ color: '#ffffff' }}>
                                                        <h3>Activity</h3>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="dashboard-sec fix-activity">
                                                {/* <div className="form-box-section mt-4">
                                                    <div className="form-list-inner">
                                                        <div className="form-list-title">
                                                            My Activity
                                                        </div>
                                                        <ul className="form-list-ul">
                                                            {
                                                                clubfollowactivity && clubfollowactivity.map((item, index) => (
                                                                    <li className="" key={index}>
                                                                        {item.firstname + " " + item.lastname} change stage
                                                                        <span> {item.what_change} to {item.who_change}</span>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>

                                                    </div>
                                                </div> */}
                                                {
                                                    clubfollowactivity && clubfollowactivity.map((item, index) => (
                                                        <div className="form-box-section activity-form-box" key={index}>
                                                            <div className="form-list-inner">
                                                                <div className="form-list-title activity-title">
                                                                    <div className="emp-name">
                                                                        <div className="emp-light">Employee:</div>
                                                                        <div className="emp-bold">{item.firstname + " " + item.lastname}</div>
                                                                    </div>
                                                                    <div className="emp-status">
                                                                        <div className="emp-light">Status:</div>
                                                                        <div className="emp-bold">{item.who_change}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-card-body-status">
                                                                    {item.notes}
                                                                </div>
                                                                <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
}

export default ClubFollowView;